import React from 'react';
import {
  Card,
  CardBody,
  Col,
  Row,
} from 'reactstrap';
import './styles.scss';

const LifeSavers = () => (
  <Col lg={4} className="life-saver">
    <div className="sticky-top pt-3 mb-2 ml-lg-3" style={{ top: 150, zIndex: 1 }}>
      <Card>
        <CardBody>
          <Row>
            <Col xs={12} className="mt-1 mb-3 border-bottom">
              <img src="/icons/five-stars.svg" alt="" className="mb-1" />
              <p><b>The whole loan process was excellent</b></p>
              <p>The whole loan process was excellent. Nick was very helpful. I would recommend anyone to needs a loan to the company.</p>
              <p><small><b>Sherri Luettke</b></small></p>
            </Col>
            <Col xs={12} className="mb-3 border-bottom">
              <img src="/icons/five-stars.svg" alt="" className="mb-1" />
              <p><b>It was quick and easy</b></p>
              <p>It was quick and easy, the rep. I worked with was very patient and walked me through the entire process. I received my money in 3 days. Awesome</p>
              <p><small><b>Wife of Ellijah</b></small></p>
            </Col>
            <Col xs={12}>
              <img src="/icons/five-stars.svg" alt="" className="mb-1" />
              <p><b>Top Notch Company with Great Offers</b></p>
              <p>LendingUSA is top notch with communication, loan offers, and expediency. Diego was an exceptional loan coordinator, always prompt with details of my loan and his personal touch does not go unnoticed. I would recommend this company on a scale of one to ten, a ten. You will not be disappointed. In addition, they are super fast when funding your loan to your bank account. Extremely impressive. Thanks for everything:)</p>
              <p><small><b>Sean</b></small></p>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  </Col>
);

export default LifeSavers;
